import React, { memo, forwardRef } from "react";
const SvgPercent = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M6.293 24.052a1 1 0 101.414 1.414L26.092 7.082a1 1 0 00-1.414-1.415L6.293 24.052zm7.292-10.689c-.555.74-1.476 1.386-2.66 1.386-1.185 0-2.106-.645-2.661-1.386-.555-.74-.84-1.671-.84-2.614 0-.943.285-1.874.84-2.614.555-.741 1.476-1.386 2.66-1.386 1.185 0 2.106.645 2.661 1.386.555.74.84 1.67.84 2.614 0 .943-.285 1.874-.84 2.614zm-2.66-.614c.828 0 1.5-.896 1.5-2 0-1.105-.672-2-1.5-2-.829 0-1.5.895-1.5 2 0 1.104.671 2 1.5 2zm13.66 10.614c-.555.74-1.476 1.386-2.66 1.386-1.185 0-2.105-.645-2.661-1.386-.555-.74-.84-1.671-.84-2.614 0-.943.285-1.874.84-2.614.556-.741 1.476-1.386 2.66-1.386 1.185 0 2.106.645 2.661 1.386.555.74.84 1.67.84 2.614 0 .943-.285 1.874-.84 2.614zm-2.66-.614c.828 0 1.5-.896 1.5-2 0-1.105-.672-2-1.5-2-.829 0-1.5.895-1.5 2 0 1.104.671 2 1.5 2z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgPercent.displayName = "SvgPercent";
const MemoForwardRef = memo(SvgPercent);
export default MemoForwardRef;
